import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AppLayout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import Performance from "@/pages/Performance";
import Timesheet from "@/pages/Timesheet";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Templates from "@/pages/Templates";
import Clients from "@/pages/Clients";
import Product from "@/pages/Product";
import Users from "@/pages/Users";
import AuditLogs from "@/pages/AuditLogs";
import Settings from "@/pages/Settings";
import { Toaster } from "sonner";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
      <div className="animate-pulse">Loading…</div>
    </div>
  );
}

function Protected({ children, leaderOnly = false, menuKey = null }) {
  const { user, loading, isLeaderView, hasMenuAccess } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (leaderOnly && !isLeaderView) return <Navigate to="/" replace />;
  if (menuKey && !hasMenuAccess(menuKey)) return <Navigate to="/" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/" element={<Protected><AppLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="performance" element={<Protected menuKey="performance"><Performance /></Protected>} />
            <Route path="timesheet" element={<Protected menuKey="timesheet"><Timesheet /></Protected>} />
            <Route path="projects" element={<Protected menuKey="projects"><Projects /></Protected>} />
            <Route path="projects/new/detail" element={<Protected menuKey="projects"><ProjectDetail /></Protected>} />
            <Route path="projects/:id/detail" element={<Protected menuKey="projects"><ProjectDetail /></Protected>} />
            <Route path="templates" element={<Protected menuKey="templates"><Templates /></Protected>} />
            <Route path="clients" element={<Protected menuKey="clients"><Clients /></Protected>} />
            <Route path="partners" element={<Navigate to="/clients" replace />} />
            <Route path="product-managers" element={<Navigate to="/clients" replace />} />
            <Route path="products" element={<Protected menuKey="products"><Product /></Protected>} />
            <Route path="products/categories" element={<Protected menuKey="products"><Product /></Protected>} />
            <Route path="products/products" element={<Protected menuKey="products"><Product /></Protected>} />
            <Route path="users" element={<Protected leaderOnly><Users /></Protected>} />
            <Route path="audit" element={<Protected leaderOnly><AuditLogs /></Protected>} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
